import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { AccountService } from '@wilson/account';
import { ShiftAssignmentMode } from '@wilson/interfaces';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseSelectFilterDirective } from '../../base-select-filter.directive';
import { FilterService } from '../../filter.service';
import { FilterOptions } from '../../options.interface';
import { MultiSelectParserService } from '../../services/multi-select-parser.service';

@Component({
  selector: 'wilson-users-list-filter',
  templateUrl: './users-list-filter.component.html',
  styleUrls: ['./users-list-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UsersListFilterComponent extends BaseSelectFilterDirective<
  FilterOptions,
  string[]
> {
  protected readonly filterService = inject(FilterService);
  private readonly accountService = inject(AccountService);
  protected readonly parserService = inject(MultiSelectParserService);

  @Input() showNoAssignment = false;
  @Input() showLabel = false;
  @Input() placeholder!: string;
  public noUserConstant = ShiftAssignmentMode.Unassigned;

  constructor() {
    super('users');
  }

  protected initializeOptions(): Observable<FilterOptions[]> {
    return this.accountService.getUsers().pipe(
      map((users) => {
        const filterOptionUsers: FilterOptions[] = users.map((user) => {
          return {
            id: user.id as string,
            name: user.firstName + ' ' + user.lastName,
          };
        });
        filterOptionUsers.sort((a, b) => a.name.localeCompare(b.name));
        return filterOptionUsers;
      }),
      catchError(() => of([])),
    );
  }
}
